import type { StageDefinition } from "../../content/stages.js";
import type { StageProgress } from "../../infrastructure/playLogApi.js";
import { relativeClearRateColor, type ClearRateRange } from "./clearRate.js";
import { ClearRateRing } from "./ClearRateRing.js";

type Props = {
  stage: StageDefinition;
  progress?: StageProgress;
  range?: ClearRateRange | null;
  onStart: () => void;
  index?: number;
};

export function StageCard({ stage, progress, range, onStart, index = 0 }: Props) {
  const clearRate = progress?.averageClearRate ?? null;
  const color = clearRate !== null ? relativeClearRateColor(clearRate, range ?? null) : undefined;

  return (
    <button
      type="button"
      className="stage-card"
      aria-label={`${stage.name}をはじめる`}
      onClick={onStart}
      style={{ animationDelay: `${index * 45}ms` }}
    >
      <ClearRateRing clearRate={clearRate} color={color} />
      <span className="stage-card-body">
        <span className="stage-card-top">
          <span className="stage-card-name">{stage.name}</span>
          <span className="stage-card-difficulty">{stage.difficulty}</span>
          {progress?.cleared ? <span className="stage-card-clear">CLEAR</span> : null}
        </span>
        <span className="stage-card-flavor">{stage.flavor}</span>
        {clearRate !== null && progress ? (
          <span className="stage-card-record">
            {`${progress.completedRunCount} 回挑戦 ・ ${progress.clearRunCount} 回成功`}
          </span>
        ) : (
          <span className="stage-card-record is-empty">まだ誰も挑戦していません</span>
        )}
      </span>
    </button>
  );
}
